import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

import CardMedia from '@mui/material/CardMedia';
import TnC from './tnc.jpg';
import { ThemeProvider } from '@mui/material/styles';
import { GlobalTheme } from '../../theme';

const PrivacyPolicyPage = () => {
    return (
        <ThemeProvider theme={GlobalTheme}>
            <CssBaseline />
            <Container maxWidth={false} disableGutters>
                <Box sx={{
                    '&.muiCard-root': { borderRadius: 0 },
                }}>
                    <CardMedia
                        sx={{ height: 500 }}
                        image={TnC}
                        title=""
                    />
                </Box>
            </Container>
            <Container maxWidth="lg" sx={{ mb: 2 }}>
                <Box sx={{ padding: 2, mt: 3 }}>
                    <Typography variant="h4" gutterBottom>
                        Disclaimer
                    </Typography>
                    <Typography id="terms-description" variant="subtitle2" fontWeight={200} component="div">
                        <Typography variant="body1" paragraph>
                            The information provided on AaryanHolidays.com is for general informational purposes only. While we strive to ensure that the content is accurate, complete, and up-to-date, we do not guarantee its accuracy or reliability. Aaryan Leisure & Holidays Pvt. Ltd. reserves the right to modify, update, or remove any information on this website without prior notice.</Typography>
                        <Typography variant="body1" paragraph>
                            Travel itineraries, packages, and prices mentioned on the website are subject to change based on availability, exchange rates, and unforeseen circumstances. Any reliance you place on the information provided is strictly at your own risk. Aaryan Holidays is not liable for any loss or damage arising from the use of this website or from reliance on its content.</Typography>
                        <Typography variant="body1" paragraph>
                            We recommend verifying details directly with our team before making any travel arrangements. External links on this site are provided for convenience, and we are not responsible for the content or practices of third-party websites.
                        </Typography>
                    </Typography>
                </Box>
            </Container>
        </ThemeProvider>
    );
};

export default PrivacyPolicyPage;
